export const VISUAL_RELATIONSHIP_TYPE = "visual-relationship";
export function isVisualRelationship(what) {
    return what.type.includes(VISUAL_RELATIONSHIP_TYPE);
}
//# sourceMappingURL=visual-relationship.js.map